import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue16 } from '../../../../Fct/generics';
import { FaArrowUp } from 'react-icons/fa';
import { getAaveV3Tokens } from '../../allowanceRequiredProtocols';
import { POOL_ADDRESSES } from '../constants';
export var Supply = createPlugin({
    protocol: 'AaveV3',
    type: 'ACTION',
    method: 'supply',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }), isPreview: true, icon: FaArrowUp }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    onBehalfOf: new FctAddress({}),
                    referralCode: new FctValue16({}),
                },
            },
            output: {},
        });
    },
    initParams: {
        methodParams: {
            referralCode: '0', // Aave has disabled referral codes, 0 by default
        },
    },
    requiredApprovals: function (params, _chainId, _walletAddress, _vaultAddress, _provider, _method, isEstimation) {
        var _a = params.methodParams, asset = _a.asset, amount = _a.amount, onBehalfOf = _a.onBehalfOf;
        var value = amount.value;
        if (isEstimation && typeof amount.estimatedValue === 'string') {
            value = amount.estimatedValue;
        }
        if (!value)
            return [];
        return [
            {
                to: asset.value,
                from: onBehalfOf.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, _a = params.methodParams, amount = _a.amount, asset = _a.asset, onBehalfOf = _a.onBehalfOf;
        if (!asset.value || !to.value || !amount.value || !onBehalfOf.value || !vaultAddress)
            return [];
        if (typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string')
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
                toReceive: [],
            },
            {
                address: to.value,
                toSpend: [],
                toReceive: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
            },
        ];
    },
});
